package com.wintermar.inspection.feature.presentation.inspection.answer

actual suspend fun processUpdateProgressPlatform(
    onUpdate: suspend () -> Unit,
    onGoToLanding: suspend () -> Unit
) {
    onGoToLanding()
}
